import React from 'react';
import SelectionCard from '../SelectionCard';

/**
 * ClassSection - Select class and subclass
 */
function ClassSection({ character, onUpdate, allData }) {
  const classes = allData.classes || {};
  const subclasses = allData.subclasses || {};

  // Get available subclasses for selected class
  const availableSubclasses = character.class
    ? Object.entries(subclasses).filter(([id, data]) => data.parentClass === character.class)
    : [];

  function handleClassSelect(classId) {
    onUpdate({
      class: classId,
      subclass: '', // Reset subclass when class changes
      domains: classes[classId]?.domains || []
    });
  }

  function handleSubclassSelect(subclassId) {
    onUpdate({
      subclass: subclassId
    });
  }

  return (
    <div className="space-y-6">
      {/* Class selection */}
      <div>
        <h4 className="text-heading-sm text-red-400 font-serif mb-3">Choose Your Class</h4>
        <p className="text-gray-300 text-small mb-4">
          Your class determines your role in combat and the domains you can access.
        </p>

        <div className="grid gap-3 md:grid-cols-2">
          {Object.entries(classes).map(([id, classData]) => (
            <SelectionCard
              key={id}
              title={classData.name}
              subtitle={`Domains: ${classData.domains?.join(', ') || 'None'}`}
              description={classData.description}
              features={classData.features}
              isSelected={character.class === id}
              onClick={() => handleClassSelect(id)}
            />
          ))}
        </div>
      </div>

      {/* Subclass selection (only show after class is selected) */}
      {character.class && (
        <div>
          <h4 className="text-heading-sm text-red-400 font-serif mb-3">Choose Your Subclass</h4>
          <p className="text-gray-300 text-small mb-4">
            Your subclass specialization provides unique abilities and features.
          </p>

          {availableSubclasses.length > 0 ? (
            <div className="grid gap-3 md:grid-cols-2">
              {availableSubclasses.map(([id, subclassData]) => (
                <SelectionCard
                  key={id}
                  title={subclassData.name}
                  description={subclassData.description}
                  features={subclassData.foundation?.features}
                  isSelected={character.subclass === id}
                  onClick={() => handleSubclassSelect(id)}
                />
              ))}
            </div>
          ) : (
            <p className="text-gray-400 text-center py-4">
              No subclasses available for {classes[character.class]?.name}
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default ClassSection;
